<template>
    <VJoyPanel v-if="panelVisible">
        <template #panel-body>
            <slot />
        </template>
    </VJoyPanel>
    <template v-else>
        <slot />
    </template>
</template>

<script setup lang="ts">
    import {VJoyPanel} from '@maltjoy/core-vue';

    defineProps<{
        panelVisible: boolean;
    }>();
</script>
